import { ReactNode } from "react";
import {
  UserResponseBody,
  RepresentationRight as ResponseRepresentationRight,
  InterestRight as ResponseInterestRight,
  UserOrgHistory,
  UserRoleHistory,
} from "../../api/UserResponseTypes";
import { Classifier } from "../../util/classifierManager";
import { DateString } from "../../util/conversionUtils";
import { Infotext } from "../../api/InfobuttonTextsTypes";
import { LinkPair } from "../../api/fetch";

export enum UserRoleType {
  ADMINISTRAATOR = "ADMINISTRAATOR",
  REGISTRIPIDAJA = "REGISTRIPIDAJA",
  KINNITAJA = "KINNITAJA",
  REGISTRI_HALDUR = "REGISTRI_HALDUR",
  VAATLEJA = "VAATLEJA",
  HUVILINE = "HUVILINE",
  VARAARVESTUS = "VARAARVESTUS",
  KVY_HALDUR = "KVY_HALDUR",
  JK_KOORDINAATOR = "JK_KOORDINAATOR",
  JK_KOOSTAJA = "JK_KOOSTAJA",
  //AVALIK = "AVALIK"
}

export interface User
  extends Omit<
    UserResponseBody,
    | "kasutusoigused"
    | "viimaneLogin"
    | "lisatud"
    | "maaratud"
    | "dokumendiKuupaev"
    | "dokumentSalvestatud"
    | "esindusoigused"
    | "huviorganisatsioonid"
  > {
  kasutusoigused: UserRoleType[];
  viimaneLogin?: DateString;
  lisatud: DateString;
  maaratud: DateString;
  dokumendiKuupaev: DateString;
  dokumentSalvestatud: DateString;
  esindusoigused: RepresentationRight[];
  huviorganisatsioonid: InterestRight[];
}

export interface RepresentationRight
  extends Omit<ResponseRepresentationRight, "padevus" | "alates" | "kuni" | "maaratud" | "muudetud"> {
  padevus: Classifier;
  alates: DateString;
  kuni: DateString;
  maaratud: DateString;
  muudetud: DateString;
}

export interface InterestRight
  extends Omit<ResponseInterestRight, "padevus" | "alates" | "kuni" | "maaratud" | "muudetud"> {
  padevus: Classifier;
  alates: DateString;
  kuni: DateString;
  maaratud: DateString;
  muudetud: DateString;
}

export interface RoleHistory
  extends Omit<
    UserRoleHistory,
    | "registriHaldur"
    | "peakasutaja"
    | "kinnitaja"
    | "registripidaja"
    | "vaatleja"
    | "varaarvestus"
    | "huviline"
    | "kvyHaldur"
    | "jkKoordinaator"
    | "jkKoostaja"
    | "maaratud"
  > {
  registriHaldur: ReactNode;
  peakasutaja: ReactNode;
  kinnitaja: ReactNode;
  registripidaja: ReactNode;
  vaatleja: ReactNode;
  varaarvestus: ReactNode;
  huviline: ReactNode;
  kvyHaldur: ReactNode;
  jkKoordinaator: ReactNode;
  jkKoostaja: ReactNode;
  maaratud: DateString;
}

export interface RepresentationRightHistory
  extends Omit<UserOrgHistory, "padevus" | "alates" | "kuni" | "maaratud" | "muudetud" | "aktiivne"> {
  padevus: Classifier;
  alates: DateString;
  kuni: DateString;
  maaratud: DateString;
  muudetud: DateString;
  aktiivne: ReactNode;
}

export interface AdditionalConfiguration {
  allowedFileExtension?: string;
  jkStrategyLink?: LinkPair;
  countryCodesLink?: LinkPair;
  adsOidLink?: LinkPair;
}

export interface InfobuttonTextsContainer {
  loadedComplex: boolean;
  complexTexts?: Infotext[];
  loadedUnitManagement: boolean; // datatable and others
  unitManagementTexts?: Infotext[];

  loadedIpTexts: boolean;
  investmentProjectTexts?: Infotext[];

  loadedIpListTexts: boolean;
  investmentListTexts?: Infotext[];

  loadedIpSearchTexts: boolean;
  investmentSearchTexts?: Infotext[];

  // grouped all bulk edit views from complex, unitmanagement and investments together
  loadedUploadTexts: boolean;
  uploadTexts?: Infotext[];

  loadedAddressTexts: boolean;
  addressTexts?: Infotext[];

  loadedAdminTexts: boolean;
  adminTexts?: Infotext[];
}

export interface PublicConfigType {
  ehrLink?: string;
  krLink?: string;
}
